"use strict";

var memoryStorage = {};

function setItem(key, val) {
  memoryStorage[key] = val;
}

function getItem(key) {
  return memoryStorage[key];
}

function removeItem(key) {
  delete memoryStorage[key];
}

module.exports = {
  setItem: setItem,
  getItem: getItem,
  removeItem: removeItem
};


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/optin/~/@flowio/storage/lib/memory-storage.js
// module id = 590
// module chunks = 0 1